import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../environments/environments'

@Injectable({
  providedIn: 'root'
})
export class AuthService {


  private loggedInStatus = JSON.parse(localStorage.getItem('loggedIn') || ('false'));

  constructor(private http: HttpClient) { }


  // auth 

  login (data:any){
   return this.http.post(`${environment.baseUrl}/auth/login`,data)
  }
  getLoginStatus() {
    return JSON.parse(localStorage.getItem('loggedIn') || ('false'));
  }

  setLoginStatus(value: any) {
    this.loggedInStatus = value;
    localStorage.setItem('loggedIn', 'true');
  }

}
